import React from 'react'
import PropTypes from 'prop-types'
import { ListCard } from '~/components/ListCard'
import {
  EXPLORE_FEED_ITEM_TAPPED,
  EXPLORE_FEED_ITEM_VIEWED,
  EXPLORE_FEED_SEE_ALL_CLICKED,
} from '~/lib/tracking-events'
import { decodeGlobalId } from '~/utils/id'
import ViewportTracking from '~/components/ViewportTracking'
import { track } from '~/utils'
import { recurringEventCollectionPropTypes } from '~/graphql/fragments/recurringEventCollection'

const RecurringEventCollectionCard = ({ t, recurringEventCollection, itemOrder }) => {
  const {
    id,
    status,
    title,
    subtitle,
    numberOfEventsOnFeedOverview,
    events,
  } = recurringEventCollection

  if (!events) return null

  const { edges: eventItems = [] } = events
  const employeeOnly = status === 'PREVIEW'

  // Don't show the card if there are no events
  if (eventItems.length === 0) {
    return null
  }

  const trackClick = eventId => {
    track(EXPLORE_FEED_ITEM_TAPPED, {
      itemId: decodeGlobalId(id),
      eventId,
      itemOrder,
      itemType: recurringEventCollection.type,
      title,
    })
  }

  const trackSeeAll = () => {
    track(EXPLORE_FEED_SEE_ALL_CLICKED, {
      itemId: decodeGlobalId(id),
      itemOrder,
      itemType: recurringEventCollection.type,
      title,
    })
  }

  return (
    <ViewportTracking
      event={EXPLORE_FEED_ITEM_VIEWED}
      payload={{
        itemId: decodeGlobalId(id),
        itemOrder,
        itemType: recurringEventCollection.type,
        title,
      }}
    >
      <ListCard
        t={t}
        title={title}
        text={subtitle}
        variant="NO_THUMBNAIL"
        dialogItems={eventItems}
        employeeOnly={employeeOnly}
        numberOfItemsOnCard={numberOfEventsOnFeedOverview}
        trackClick={trackClick}
        trackSeeAll={trackSeeAll}
      />
    </ViewportTracking>
  )
}

RecurringEventCollectionCard.propTypes = {
  t: PropTypes.func.isRequired,
  recurringEventCollection: recurringEventCollectionPropTypes.isRequired,
  itemOrder: PropTypes.number.isRequired,
}

export default RecurringEventCollectionCard
